<!--<div class="ldn-container">-->
    <!--<button class="ldn-button" (click)="addItem()">Dodaj</button>-->
<!--</div>-->
<!--<div class="grid" [ngGrid]="grid">-->
    <!--<div *ngFor="let item of gridItems" class="grid-item" [ngGridItem]="item.config">-->
        <!--<div class="grid-item__header">-->
            <!--<i class="fas fa-{{item.iconClass}}"></i> <strong>{{item.title}}</strong>-->
        <!--</div>-->
        <!--<div class="grid-item__content">-->
            <!--{{item | json}}-->
        <!--</div>-->
        <!--<div class="grid-item__footer">-->
            <!--<button class="ldn-button ldn-button&#45;&#45;secondary" (click)="removeItem(item)">Usuń</button>-->
        <!--</div>-->
    <!--</div>-->
<!--</div>-->
<h1>Dashboard</h1>